import { AVAILABLE_SIZES } from "../components/editor/ResizeSection";

const DEFAULT_SIZE = AVAILABLE_SIZES.FACEBOOK;
const GENERAL_SIZE = AVAILABLE_SIZES.GENERAL;

export const TEMPLATES = [
  {
    id: "main_image",
    preview: "/templates/2-preview.png",
    width: 900,
    height: 700,
    fonts: [],
    pages: [
      {
        id: "main_image_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 0,
            y: 0,
            width: 900,
            height: 700,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "https://images.unsplash.com/photo-1526367790999-0150786686a2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwxMHx8ZGVsaXZlcnl8ZW58MHx8fHwxNjI4MDU3NTUw&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
            keepRatio: false,
          },
        ],
      },
    ],
  },
  {
    id: "template_1",
    preview: "/templates/2-preview.png",
    width: DEFAULT_SIZE.width,
    height: DEFAULT_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_1_page",
        children: [
          {
            id: "figure-2",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 421.09917364339094,
            y: -267.63735177865607,
            width: 357.8016527132181,
            height: 357.80165271321783,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMzAiIGZpbGw9InJnYigwLCAxNjEsIDI1NSkiIC8+PC9zdmc+",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(224,131,30,1)",
            },
          },
          {
            id: "custom_image",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 189.14300937954872,
            y: 200.30382662626153,
            width: 821.7139812309022,
            height: 548.4940824716266,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "https://images.unsplash.com/photo-1526367790999-0150786686a2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwxMHx8ZGVsaXZlcnl8ZW58MHx8fHwxNjI4MDU3NTUw&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
            keepRatio: false,
          },
          {
            id: "caption-1-166",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 67.04347823586988,
            y: 117.0538266262614,
            width: 1065.91304351826,
            height: 55,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            text: "EXPRESS DELIVERY SERVICE",
            placeholder: "",
            fontSize: 48.25513332235936,
            fontFamily: "Archivo Black",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(83,49,20,1)",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.1,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5,
          },
          {
            id: "figure-3",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 978.2824357377441,
            y: 377.31726695805025,
            width: 128,
            height: 128,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cmVjdCB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIgZmlsbD0ibm9uZSIvPjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjgiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSI2MCIgcj0iOCIvPjxjaXJjbGUgY3g9IjE5NiIgY3k9IjYwIiByPSI4Ii8+PGNpcmNsZSBjeD0iNjAiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSIxOTYiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSI2MCIgY3k9IjE5NiIgcj0iOCIvPjxjaXJjbGUgY3g9IjEyOCIgY3k9IjE5NiIgcj0iOCIvPjxjaXJjbGUgY3g9IjE5NiIgY3k9IjE5NiIgcj0iOCIvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: true,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {},
          },
          {
            id: "figure-4",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 160.56845450684153,
            y: 172.05382662626138,
            width: 62.8508902445853,
            height: 62.85089024458531,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(44,26,11,1)",
            },
          },
          {
            id: "figure-5",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 979.4315454931589,
            y: 172.05382662626144,
            width: 62.8508902445853,
            height: 62.85089024458531,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(44,26,11,1)",
            },
          },
          {
            id: "RZgM-QR6s0",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 95.41934475142682,
            y: 377.3172669580502,
            width: 128,
            height: 128,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTYgMjU2Ij48cmVjdCB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIgZmlsbD0ibm9uZSIvPjxjaXJjbGUgY3g9IjYwIiBjeT0iNjAiIHI9IjgiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSI2MCIgcj0iOCIvPjxjaXJjbGUgY3g9IjE5NiIgY3k9IjYwIiByPSI4Ii8+PGNpcmNsZSBjeD0iNjAiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSIxMjgiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSIxOTYiIGN5PSIxMjgiIHI9IjgiLz48Y2lyY2xlIGN4PSI2MCIgY3k9IjE5NiIgcj0iOCIvPjxjaXJjbGUgY3g9IjEyOCIgY3k9IjE5NiIgcj0iOCIvPjxjaXJjbGUgY3g9IjE5NiIgY3k9IjE5NiIgcj0iOCIvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: true,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {},
          },
        ],
        background: "#F1BA4B",
      },
    ],
  },
  {
    id: "template_2",
    preview: "/templates/1-preview.png",
    width: DEFAULT_SIZE.width,
    height: DEFAULT_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_2_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 2.8115210316639953e-11,
            y: 3.279925776301606e-13,
            width: 683.9506773031094,
            height: 629.9999999999998,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "https://images.unsplash.com/photo-1597078889966-e375fdcd95b4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHw5fHxmYXRoZXJzJTIwZGF5fGVufDB8fHx8MTYzMTk2OTQxNQ&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
            keepRatio: false,
          },
          {
            id: "figure-1",
            type: "svg",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 684.0681918188346,
            y: 0,
            width: 515.9318081811656,
            height: 630,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
            cornerRadius: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(32,93,88,1)",
            },
          },
          {
            id: "caption-1-512",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 691.5340959044175,
            y: 314.85708584777115,
            width: 501,
            height: 344,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            text: "You are truly the best",
            placeholder: "",
            fontSize: 114,
            fontFamily: "Suranna",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.0000000000000002,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5,
          },
          {
            id: "caption-3",
            type: "text",
            name: "",
            opacity: 1,
            visible: true,
            selectable: true,
            removable: true,
            alwaysOnTop: false,
            showInExport: true,
            x: 716.0340959044174,
            y: 119.45717848826567,
            width: 452,
            height: 51,
            rotation: 0,
            animations: [],
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            shadowOpacity: 1,
            draggable: true,
            resizable: true,
            contentEditable: true,
            styleEditable: true,
            text: "To my Dearest Dad!",
            placeholder: "",
            fontSize: 41,
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            verticalAlign: "top",
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
            backgroundEnabled: false,
            backgroundColor: "#7ED321",
            backgroundOpacity: 1,
            backgroundCornerRadius: 0.5,
            backgroundPadding: 0.5,
          },
        ],
      },
    ],
  },
  {
    id: "template_3",
    preview: "/templates/3-preview.png", 
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_3_page",
        children: [
          {
            id: "t549p6RU5k",
            type: "svg",
            x: 72.68292682927793,
            y: 77.24390243902444,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 405.6261812314055,
            height: 916.6505714753097,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: { "rgb(0, 161, 255)": "rgba(231,147,9,1)" },
          },
          {
            id: "_7xzAz4tR7",
            type: "text",
            x: 116.87863566436334,
            y: 988.3888190043142,
            rotation: -90.00000000000016,
            opacity: 0.14,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "FASHION",
            placeholder: "",
            fontSize: 263.7804114241485,
            fontFamily: "Anton",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(246,245,245,1)",
            align: "center",
            width: 911.144916565288,
            height: 316.5364937089782,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "custom_image",
            type: "image",
            x: 157.4107142568193,
            y: 230.14091005540735,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            width: 410.8437808661969,
            height: 643.678215509023,
            src: "https://images.unsplash.com/photo-1588731247530-4076fc99173e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHw2N3x8TUVOfGVufDB8fHx8MTYyMjQ1NTQ1NQ&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 0.957412658143091,
            cropHeight: 0.9999999999999994,
            flipX: false,
            flipY: false,
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "ZRT6WIOYMm",
            type: "svg",
            x: 822.8201209916433,
            y: -2.840310899297967e-14,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 182.033537544942,
            height: 206.8772048425661,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: { "rgb(0,161,255)": "rgba(231,147,9,1)" },
          },
          {
            id: "gYzFymQ9BH",
            type: "text",
            x: 676.4845973913646,
            y: 17.195121951219576,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "LO\nGO",
            placeholder: "",
            fontSize: 109.5158309996954,
            fontFamily: "Anton",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            width: 473.10838995372916,
            height: 197.12849579945177,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 0.9000000000000002,
            letterSpacing: 0,
          },
          {
            id: "6esf4gvny2",
            type: "text",
            x: 597.1824827272969,
            y: 332.25306570458946,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "Fashion ",
            placeholder: "",
            fontSize: 123,
            fontFamily: "Anton",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(245,166, 35, 1) ",
            align: "center",
            width: 486.88639868292506,
            height: 147.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "vCsrFknDq4",
            type: "text",
            x: 549,
            y: 359.9705974289565,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "Sale",
            placeholder: "",
            fontSize: 261,
            fontFamily: "Allura",
            fontStyle: "normal",
            fontWeight: "bold",
            textDecoration: "",
            fill: "rgba(255, 255, 255, 1)",
            align: "center",
            width: 506.31523214291525,
            height: 313.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "EQ_E_gnb6D",
            type: "text",
            x: 650.3874668878393,
            y: 602.3705974289563,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod",
            placeholder: "",
            fontSize: 26,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255, 255, 255, 1)",
            align: "center",
            width: 349.20677162224246,
            height: 93.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "SqNh2Xrq3J",
            type: "svg",
            x: 676.4845973913665,
            y: 786.6689107730984,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            src: "data: image/ svg + xml; base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI + PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg == ",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 286.97560975609525,
            height: 81.51219512195186,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: { "rgb(0, 161, 255)": "rgba(245, 166, 35, 1)" },
          },
          {
            id: "sufipFIidB",
            type: "text",
            x: 675.8175680828393,
            y: 794.5957400413924,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "Shop Now",
            placeholder: "",
            fontSize: 58.58819510430823,
            fontFamily: "Anton",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "black",
            align: "center",
            width: 293.84409112374146,
            height: 70.30583412516987,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "HicBlRFLfy",
            type: "text",
            x: 627.5542302503363,
            y: 942.4408153777484,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "WWW.SHOP.COM",
            placeholder: "",
            fontSize: 26,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255, 255, 255, 1) ",
            align: "center",
            width: 349.20677162224246,
            height: 31.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
        ],
        background:
          "https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwzNzl8fHBhdHRlcm58ZW58MHx8fHwxNjIyNDUzNzY2&ixlib=rb-1.2.1&q=80&w=1080",
      },
    ],
  },
  {
    id: "template_4",
    preview: "/templates/4-preview.png",
    width: 1080,
    height: 1080,
    fonts: [],
    pages: [
      {
        id: "template_4_page",
        children: [
          {
            id: "DHR1fOEx7F",
            type: "svg",
            x: -32.09845131860976,
            y: 3.1833964978659067e-15,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 1144.1969026372205,
            height: 535.7090977591724,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(245,190,102,1)",
            },
          },
          {
            id: "yzp5iCe7P0",
            type: "svg",
            x: 92.60805777115212,
            y: 440.04878048780495,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 769.0243902438998,
            height: 534.5853658536579,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(216,155,59,1)",
            },
          },
          {
            id: "custom_image",
            type: "image",
            x: 994.1992135740122,
            y: 309.7906514948504,
            rotation: 89.99999999999949,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 602.0865685326492,
            height: 860.9837930016885,
            src: "https://images.unsplash.com/photo-1600184430626-1dd6087315d8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHw3fHx3YWZmbGV8ZW58MHx8fHwxNjM1NTkwMjc3&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0.00038834951456290234,
            cropWidth: 1,
            cropHeight: 0.9996116504854371,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "4MkzwRMNqV",
            type: "text",
            x: 39.00000000000057,
            y: 164.47893912348854,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Waiting for a waffle o'clock",
            placeholder: "",
            fontSize: 66,
            fontFamily: "Libre Baskerville",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(189,130,36,1)",
            align: "center",
            width: 1002,
            height: 79.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "BAgdNcgp9x",
            type: "svg",
            x: 930.1992135740174,
            y: 752.121951219512,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzIwMEUzMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEwLjIxMzUzNTQsMC40NDEzMjk4OTQgTDEyLjUzMDE5MDcsNS4wOTY2ODg3MSBDMTIuNjQzNzcwOSw1LjMzMDY3MTYgMTIuODY3MzIyOSw1LjQ5NDIzNzE1IDEzLjEyNzQ1MzQsNS41MzM2ODU5OSBMMTguMzEyNzc5NSw2LjI4MjgyNDE5IEMxOC41MjMyMDEzLDYuMzExNTEzNTggMTguNzEzMjcxLDYuNDIxODY1OSAxOC44NDA3MjY1LDYuNTg5MzQ0MzEgQzE4Ljk2ODE4MjEsNi43NTY4MjI3MiAxOS4wMjI0NTg0LDYuOTY3NTQ0NCAxOC45OTE0ODcxLDcuMTc0NjU1MzggQzE4Ljk2NTQzMzYsNy4zNDQ5MDQwMSAxOC44ODI2NjA1LDcuNTAxNzc2NjIgMTguNzU2MjAxOCw3LjYyMDU3MDk4IEwxNS4wMDA2ODY0LDExLjI1OTI0MjIgQzE0LjgxMDg3NjUsMTEuNDM4NTY1NyAxNC43MjU3ODAzLDExLjcwMDIxODcgMTQuNzc0NDUwNSwxMS45NTQ4NzA2IEwxNS42NzkzOTQsMTcuMDgyODk5OSBDMTUuNzQ0ODc3NCwxNy41MDU0MzU1IDE1LjQ1NTIxNDcsMTcuOTAxOTE1NCAxNS4wMjc4MzQ3LDE3Ljk3NDczMTEgQzE0Ljg1MTYwODksMTguMDAxOTM2IDE0LjY3MTE2NDIsMTcuOTczODU3NiAxNC41MTIwMTY5LDE3Ljg5NDQ2NjMgTDkuODg3NzU1NzUsMTUuNDc3NjAzOCBDOS42NTY3NTcyMSwxNS4zNTIyNDg1IDkuMzc2NzAwNjQsMTUuMzUyMjQ4NSA5LjE0NTcwMjEsMTUuNDc3NjAzOCBMNC40OTQyOTI2NiwxNy45MTIzMDI5IEM0LjEwNDA0NDIsMTguMTA5NjUyMSAzLjYyNTMwNzU3LDE3Ljk2Mjk1OCAzLjQxNzQwOTkzLDE3LjU4MjMyNTQgQzMuMzM2MzUxODQsMTcuNDI4ODUyMyAzLjMwNzc4NDM4LDE3LjI1MzY3NDggMy4zMzU5NjUwMiwxNy4wODI4OTk5IEw0LjI0MDkwODQ5LDExLjk1NDg3MDYgQzQuMjg0Njc4NjUsMTEuNzAwNTQwNSA0LjIwMDMwNTYzLDExLjQ0MTExMSA0LjAxNDY3MjYyLDExLjI1OTI0MjIgTDAuMjMyMDA4OTEsNy42MjA1NzA5OCBDLTAuMDc3MzM2MzAzNCw3LjMxMTUwMzEyIC0wLjA3NzMzNjMwMzQsNi44MTQ4NDk4NSAwLjIzMjAwODkxLDYuNTA1NzgxOTkgQzAuMzU4MjU5MTQ4LDYuMzkwNTgzNCAwLjUxNTIxNjY0OCw2LjMxMzI0MTc3IDAuNjg0NDgwNjQ2LDYuMjgyODI0MTkgTDUuODY5ODA2NzMsNS41MzM2ODU5OSBDNi4xMjg3MDgzNyw1LjQ5MTM2MTQxIDYuMzUxMDUxNTEsNS4zMjg2ODAzMiA2LjQ2NzA2OTQzLDUuMDk2Njg4NzEgTDguNzgzNzI0NzEsMC40NDEzMjk4OTQgQzguODc1MjYyMTMsMC4yNTI1Njg2NCA5LjA0MDI2OTEyLDAuMTA4MjM2NjI4IDkuMjQxMzE3OTQsMC4wNDEwNzE5ODA4IEM5LjQ0MjM2Njc3LC0wLjAyNjA5MjY2NjcgOS42NjI0MTc4MywtMC4wMTAzOTc1MDE5IDkuODUxNTU4MDEsMC4wODQ1OTc0MTc5IEMxMC4wMDc2MDgzLDAuMTYyNTkwNjkgMTAuMTM0Mzk1NCwwLjI4NzU0MDcyNCAxMC4yMTM1MzU0LDAuNDQxMzI5ODk0IFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuNSAzKSIvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: true,
            flipX: false,
            flipY: false,
            width: 128,
            height: 128,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "#200E32": "rgba(255,255,255,1)",
            },
          },
          {
            id: "mIYW6wl4XS",
            type: "svg",
            x: 43.72341686100141,
            y: 391.16413957765434,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,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",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: true,
            flipX: false,
            flipY: false,
            width: 97.76928182030144,
            height: 97.76928182030143,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "#200E32": "rgba(255,255,255,1)",
            },
          },
        ],
        background: "rgba(245,234,187,1)",
      },
    ],
  },
  {
    id: "template_5",
    preview: "/templates/5-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_5_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            x: -20.3131141855975,
            y: -713.483990212464,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 1100.3131141856,
            height: 1489.22970198077,
            src: "https://images.unsplash.com/photo-1574144792274-3da957488054?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwzM3x8aG9uZXltb29ufGVufDB8fHx8MTYzNDM4MzIwMw&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 0.903421950577502,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "NGM1ty6eyM",
            type: "svg",
            x: -175.295027006025,
            y: 597.482381220514,
            rotation: -39.7530259084445,
            opacity: 0.67,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 1045.45231072394,
            height: 907.274145888381,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(255,255,255,1)",
            },
          },
          {
            id: "CoFnFpeu9r",
            type: "text",
            x: -106.327288800116,
            y: 682.4,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Travel",
            placeholder: "",
            fontSize: 288,
            fontFamily: "Galada",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(14,9,143,1)",
            align: "center",
            width: 1246,
            height: 345.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "2fQBv6YdOc",
            type: "text",
            x: 291.559341486324,
            y: 659.015770442066,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "The World",
            placeholder: "",
            fontSize: 116,
            fontFamily: "Galada",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(4,178,245,1)",
            align: "center",
            width: 717,
            height: 139.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "wXUdhfemZM",
            type: "text",
            x: 182,
            y: 900.390243902441,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Explore The World",
            placeholder: "",
            fontSize: 71,
            fontFamily: "Caveat Brush",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(4,178,245,1)",
            align: "center",
            width: 716,
            height: 85.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "P_aFVJ5eLp",
            type: "svg",
            x: 933.559341486324,
            y: 1092.99024390244,
            rotation: -90,
            opacity: 0.81,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 150,
            height: 150,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {},
          },
          {
            id: "GVtv8f0MPX",
            type: "svg",
            x: 150,
            y: 603.4,
            rotation: 89.9999999999998,
            opacity: 0.81,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 150,
            height: 150,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {},
          },
        ],
        background: "white",
      },
    ],
  },
  {
    id: "template_6",
    preview: "/templates/6-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_6_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            x: -9.25053533190527,
            y: -55.5032119914347,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 1098.50107066381,
            height: 1248.82226980728,
            src: "https://images.unsplash.com/photo-1596813362035-3edcff0c2487?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwyM3x8ZmVtYWxlJTIwZmFjZXxlbnwwfHx8fDE2MzQ5NTE0NjY&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 0.852631578947368,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "UXLx49Q_r2",
            type: "svg",
            x: 139.349657027375,
            y: 141.662290860351,
            rotation: 0,
            opacity: 0.63,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMzAiIGZpbGw9InJnYigwLCAxNjEsIDI1NSkiIC8+PC9zdmc+",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 796.675418279298,
            height: 796.675418279298,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(37,42,87,1)",
            },
          },
          {
            id: "2RvNxjgj1t",
            type: "text",
            x: 259.5,
            y: 365.034437561598,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "It's one thing to make a picture of what a person looks like, it's another thing to make a portrait of who they are.",
            placeholder: "",
            fontSize: 53,
            fontFamily: "Alata",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            width: 561,
            height: 381.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "u4SPRX7q30",
            type: "text",
            x: 261,
            y: 282.612419700215,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "DAILY INSPIRATION",
            placeholder: "",
            fontSize: 51,
            fontFamily: "Alata",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(243,236,151,1)",
            align: "center",
            width: 558,
            height: 61.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "WTpilTFVK2",
            type: "text",
            x: 260.99999999,
            y: 785.949212722198,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "UNKNOWN",
            placeholder: "",
            fontSize: 38,
            fontFamily: "Alata",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(243,236,151,1)",
            align: "center",
            width: 558,
            height: 45.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
        ],
        background: "white",
      },
    ],
  },
  {
    id: "template_7",
    preview: "/templates/7-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_7_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            x: -185.292105614365,
            y: 342.405068044908,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 1362.63505581801,
            height: 909.558899758524,
            src: "https://images.unsplash.com/photo-1621955511667-e2c316e4575d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHw3NXx8c3RyYXdiZXJyeSUyMGNha2V8ZW58MHx8fHwxNjM1NTg5NzI5&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 0.998751560549313,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "pIZTKQUPbU",
            type: "svg",
            x: -42.7711629364499,
            y: 9.32492826165098e-16,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 1165.5423258729,
            height: 538.615496604608,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(245,168,129,1)",
            },
          },
          {
            id: "e3wWuUlf0P",
            type: "text",
            x: 77.77116293645,
            y: 90.3029720228708,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "THE 'ZERTS BAR",
            placeholder: "",
            fontSize: 116,
            fontFamily: "Asset",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(184,37,13,1)",
            align: "left",
            width: 1045,
            height: 278.4,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 0.8,
            letterSpacing: 0,
          },
          {
            id: "HcOih7QZl6",
            type: "text",
            x: 654.364638273701,
            y: 394.634146341464,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Satisfy your sweet cravings",
            placeholder: "",
            fontSize: 47,
            fontFamily: "Telex",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(184,37,13,1)",
            align: "right",
            width: 335,
            height: 112.8,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
        ],
        background: "rgba(248,163,130,1)",
      },
    ],
  },
  {
    id: "template_8",
    preview: "/templates/8-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_8_page",
        children: [
          {
            id: "jVu-Ju2zxZ",
            type: "svg",
            x: 57.7728304270632,
            y: 643.467723496732,
            rotation: -11.6633188544284,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 912.617326272343,
            height: 137.716573845096,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(240,236,185,1)",
            },
          },
          {
            id: "L1maDLsPQU",
            type: "svg",
            x: 84.4929421978722,
            y: 339.747318983706,
            rotation: 7.84053166798787,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 919.096856434778,
            height: 195.871690719401,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(240,236,185,1)",
            },
          },
          {
            id: "custom_image",
            type: "image",
            x: 921.815791359181,
            y: 271.435710270062,
            rotation: 89.9999999999998,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 587.267067561571,
            height: 734.083834451964,
            src: "https://images.unsplash.com/photo-1552611052-33e04de081de?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwyMHx8UkFNRU58ZW58MHx8fHwxNjM1NTg5MzE1&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 0.999999999999999,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "rgba(240,236,185,1)",
            borderSize: 15,
          },
          {
            id: "hEPTj-v9SG",
            type: "text",
            x: 171.2738741332,
            y: 87.6143308141234,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Coming Soon",
            placeholder: "",
            fontSize: 129,
            fontFamily: "Sedgwick Ave Display",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(240,236,185,1)",
            align: "center",
            width: 767,
            height: 154.8,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "sdTGsDDFd8",
            type: "text",
            x: 570.732172374399,
            y: 883.0428499114,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Best Noodle in Town",
            placeholder: "",
            fontSize: 56,
            fontFamily: "Alata",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(240,236,185,1)",
            align: "right",
            width: 352,
            height: 123.2,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.1,
            letterSpacing: 0,
          },
        ],
        background: "rgba(166,192,24,1)",
      },
    ],
  },
  {
    id: "template_9",
    preview: "/templates/9-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_9_page",
        children: [
          {
            id: "custom_image",
            type: "image",
            x: -404.004984635656,
            y: 0,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            width: 1196.00143123202,
            height: 1080,
            src: "https://images.unsplash.com/photo-1581092917372-d2db8f7904c6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHwzN3x8Y2l2aWwlMjBlbmdpbmVlcnxlbnwwfHx8fDE2MzMzOTkwNzI&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 0.738272488414827,
            cropHeight: 1,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "cmpnw6oMoa",
            type: "svg",
            x: 414.777634710198,
            y: 1152.61514067506,
            rotation: -100.686295687189,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 729.877956771103,
            height: 729.877956771104,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(0,0,0,1)",
            },
          },
          {
            id: "xw-A8_nZ2Q",
            type: "svg",
            x: 882.101697074499,
            y: 743.741120519469,
            rotation: -160.521816594711,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 729.877956771103,
            height: 729.877956771104,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(0,0,0,1)",
            },
          },
          {
            id: "Qqamu5d5rc",
            type: "svg",
            x: 366.848232842883,
            y: 1316.10984875415,
            rotation: -101.171164977266,
            opacity: 0.43,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHBvbHlnb24gZmlsbD0icmdiKDAsIDE2MSwgMjU1KSIgcG9pbnRzPSIwIDAsIDYwIDYwLCAwIDYwIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 948.450262520344,
            height: 948.450262520344,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(255,62,0,1)",
            },
          },
          {
            id: "yfrhnurYtG",
            type: "svg",
            x: -13.0058976629802,
            y: 556.999999999998,
            rotation: 0,
            opacity: 0.73,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 1146.01228885424,
            height: 310,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(255,62,0,1)",
            },
          },
          {
            id: "K9Goh_EcMi",
            type: "text",
            x: 69.2113358855066,
            y: 591.741120519469,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "BIOLOGICAL COMPANY",
            placeholder: "",
            fontSize: 76,
            fontFamily: "Archivo Black",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "left",
            width: 601,
            height: 152,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1,
            letterSpacing: 0,
          },
          {
            id: "skIMhEm5Rr",
            type: "text",
            x: 69.2113358855066,
            y: 752.993281222964,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            placeholder: "",
            fontSize: 24,
            fontFamily: "Archivo",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "left",
            width: 532,
            height: 86.4,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "ExNDoPI4LS",
            type: "svg",
            x: -127.507156160101,
            y: 920.664855252251,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjggMTQgODQgNzIiPjxwb2x5Z29uIHN0cm9rZT0icmdiYSg5OCwgMTk3LCAyNTUsIDEpIiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9Im5vbmUiIHBvaW50cz0iMzAuMSw4NC41IDEwLjIsNTAgMzAuMSwxNS41IDY5LjksMTUuNSA4OS44LDUwIDY5LjksODQuNSIgLz48L3N2Zz4=",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 418.057668872374,
            height: 358.335144747749,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgba(98, 197, 255, 1)": "rgba(255,62,0,1)",
            },
          },
          {
            id: "q__wevVR3D",
            type: "svg",
            x: 106.49511407,
            y: 984.664855252251,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            selectable: true,
            alwaysOnTop: false,
            showInExport: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjggMTQgODQgNzIiPjxwb2x5Z29uIHN0cm9rZT0icmdiYSg5OCwgMTk3LCAyNTUsIDEpIiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9Im5vbmUiIHBvaW50cz0iMzAuMSw4NC41IDEwLjIsNTAgMzAuMSwxNS41IDY5LjksMTUuNSA4OS44LDUwIDY5LjksODQuNSIgLz48L3N2Zz4=",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 418.057668872374,
            height: 358.335144747749,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgba(98, 197, 255, 1)": "rgba(255,62,0,1)",
            },
          },
        ],
        background: "rgba(0,0,0,1)",
      },
    ],
  },
  {
    id: "template_10",
    preview: "/templates/10-preview.png",
    width: GENERAL_SIZE.width,
    height: GENERAL_SIZE.height,
    fonts: [],
    pages: [
      {
        id: "template_10_page",
        children: [
          {
            id: "xG6Sk4IG5t",
            type: "svg",
            x: 127.50992281691,
            y: 104.607970089855,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: true,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMzAiIGZpbGw9InJnYigwLCAxNjEsIDI1NSkiIC8+PC9zdmc+",

            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 824.980154366179,
            height: 870.784059820289,
            borderColor: "rgba(255,255,255,1)",
            borderSize: 5,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(58,10,17,1)",
            },
          },
          {
            id: "custom_image",
            type: "image",
            x: 185.247090510752,
            y: 142.985717233918,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            width: 713.672485645159,
            height: 692.236216349929,
            src: "https://images.unsplash.com/photo-1578896046966-21532b292c33?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMTY5OTZ8MHwxfHNlYXJjaHw1N3x8Ym9obyUyMHN0eWV8ZW58MHx8fHwxNjMxOTc1MTY3&ixlib=rb-1.2.1&q=80&w=1080",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 0.646642290661894,
            cornerRadius: 0,
            flipX: false,
            flipY: false,
            clipSrc: "",
            borderColor: "black",
            borderSize: 0,
          },
          {
            id: "wlu8piE0PO",
            type: "svg",
            x: -12.0833333133347,
            y: 775.836901352293,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            styleEditable: true,
            src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSJyZ2IoMCwgMTYxLCAyNTUpIiAvPjwvc3ZnPg==",
            maskSrc: "",
            cropX: 0,
            cropY: 0,
            cropWidth: 1,
            cropHeight: 1,
            keepRatio: false,
            flipX: false,
            flipY: false,
            width: 1108.33333333333,
            height: 118.770064463108,
            borderColor: "black",
            borderSize: 0,
            colorsReplace: {
              "rgb(0, 161, 255)": "rgba(160,73,88,1)",
            },
          },
          {
            id: "OQGOjJGNes",
            type: "text",
            x: 272.083333323331,
            y: 787.221933583847,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "GET 20% OFF",
            placeholder: "",
            fontSize: 80,
            fontFamily: "Abhaya Libre",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            width: 540,
            height: 96,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "YEpDuzfm0w",
            type: "text",
            x: 269.99999999,
            y: 906.606965815401,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "WINTER COLLECTION",
            placeholder: "",
            fontSize: 33,
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            width: 540,
            height: 39.6,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
          {
            id: "oPZryVUU0Q",
            type: "text",
            x: 272.083333323331,
            y: 614.421933583847,
            rotation: 0,
            opacity: 1,
            locked: false,
            blurEnabled: false,
            blurRadius: 10,
            brightnessEnabled: false,
            brightness: 0,
            sepiaEnabled: false,
            grayscaleEnabled: false,
            shadowEnabled: false,
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: "black",
            text: "Sale",
            placeholder: "",
            fontSize: 144,
            fontFamily: "Dancing Script",
            fontStyle: "normal",
            fontWeight: "normal",
            textDecoration: "",
            fill: "rgba(255,255,255,1)",
            align: "center",
            width: 541,
            height: 172.8,
            strokeWidth: 0,
            stroke: "black",
            lineHeight: 1.2,
            letterSpacing: 0,
          },
        ],
        background: "rgba(58,10,17,1)",
      },
    ],
  },
];
